import type { MicErrorClass } from './audioDeviceTypes';

// Chromium picks the name by what is left: no microphone at all fails as `NotFoundError`, and an
// `exact` device id that no listed microphone matches fails as `OverconstrainedError`.
const NOT_FOUND_ERRORS = new Set(['NotFoundError', 'OverconstrainedError']);
const NOT_ALLOWED_ERRORS = new Set(['NotAllowedError', 'SecurityError']);

export const isMicNotFoundError = (error: unknown): boolean =>
  error instanceof DOMException && NOT_FOUND_ERRORS.has(error.name);

export function classifyMicError(error: unknown): MicErrorClass {
  if (isMicNotFoundError(error)) return 'not-found';
  if (error instanceof DOMException && NOT_ALLOWED_ERRORS.has(error.name)) return 'not-allowed';
  return 'not-readable';
}
